<div class="outline-file-upload" [class.upload-complete]="uploadProgress === 100" [class.error]="required && isSubmitted && !fileName">
    <div *ngIf="!fileName">{{ label }}</div>
    <input type="file" hidden #fileUpload (change)="onFileChange($event)" accept=".jpg,.jpeg,.png, .pdf">
    <ng-container *ngIf="fileName">
        <div class="d-flex align-items-center justify-content-start">
            <span class="fa fa-picture-o" aria-hidden="true"></span>&nbsp;&nbsp;&nbsp;
            <div class="file_uploaded">
                <span class="file-name">{{ fileName }}</span><br><span class="sizeUpload">{{ fileSize }} – {{ uploadProgress }}% uploaded</span>
            </div>
        </div>
    </ng-container>
    <mat-error *ngIf="required && isSubmitted && !fileName">File is required</mat-error>
    <span matSuffix color="primary" class="file-upload-label buttonFileUpload" (click)="fileUpload.click()">&nbsp;&nbsp;<span>Choose File</span></span>
</div>